export const DEFAULT_NOTIFICATION_DURATION = 4.5;